import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import BackgroundImage, { IFluidObject } from 'gatsby-background-image';
import DefaultTitle from '../../components/DefaultTitle';
import DefaultParagraph from '../../components/DefaultParagraph';
import useWindowWidth from '../../hooks/useWindowWidth';
import BouncingArrow from './BouncingArrow';


const Container = styled(BackgroundImage)<{ fluid: IFluidObject }>`
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  height: calc(100vh - ${({ theme }) => theme.navbarHeight.mobile});
  background-size: cover;
  padding: 172px 25px 100px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    height: calc(100vh - ${({ theme }) => theme.navbarHeight.desktop});
    padding: 223px 25px 100px 190px;
  }
`;

const Text = styled(DefaultParagraph)`
  font-size: ${({ theme }) => theme.fontSize.medium};
  margin-top: 20px;
  text-align: left;
  max-width: 550px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    align-self: flex-start;
    margin-top: -20px;
  }
`;

const Title = styled(DefaultTitle)`
  font-size: ${({ theme }) => theme.headingSize.medium};
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    text-align: left;
    align-self: flex-start;
  }
`;

const TopBanner = () => {
  const theme = useContext(ThemeContext);
  const width = useWindowWidth();
  const mediumWidth = theme.screenSizeWidthWithoutPx.medium;

  const {
    hero, heroBig,
  } = useStaticQuery(graphql`
        query {
          hero: file(name: {eq: "heroImage"}) {
            childImageSharp {
              fluid(quality: 100, maxWidth: 1000) {
                ...GatsbyImageSharpFluid_withWebp
                  } 
              }
          }
          heroBig: file(name: {eq: "bigHeroImage"}) {
            childImageSharp {
              fluid(quality: 100, maxWidth: 1920) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
  `);

  return (
    <Container
      fluid={width > mediumWidth ? heroBig.childImageSharp.fluid : hero.childImageSharp.fluid}
    >
      <Title color={theme.colors.dark}>
        remonty
        <br />
        i wykończenia wnętrz
      </Title>
      <Text color={theme.colors.dark}>
        Nazywam się Miłosz Kaffka - razem z moją ekipą specjalistów zajmujemy
        się
        <strong> remontami nieruchomości </strong>
        od ponad dziesięciu lat.
      </Text>
      <BouncingArrow />
    </Container>
  );
};

export default TopBanner;
